import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Button } from "@components/buttons";
import { usePartnerRegistrationStore } from "@state/context/membership/registration-types/PartnerRegistrationStoreContext";
import {
	RegistrationCity,
	RegistrationHouseNumber,
	RegistrationMonthlyLimit,
	RegistrationPOB,
	RegistrationStreet,
	RegistrationZIPCode,
} from "@features/membership/mobile/registration-types/registration";
import {
	PartnerRegistrationConditions,
	PartnerRegistrationLanguage,
	PartnerRegistrationNationality,
	PartnerRegistrationPromotion,
} from "@features/membership/mobile/registration-types/partner-registration";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { useFormContext } from "react-hook-form";

export const PartnerRegistrationContactDetails = observer(
	function PartnerRegistrationContactDetails() {
		const {
			formState: { isSubmitting },
		} = useFormContext();

		const { t } = useTranslation("registration");

		const { previousStep, countryData, languageData, gamingLimitsData } =
			usePartnerRegistrationStore();

		return (
			<>
				<div className="card--membership__form form--grid">
					<RegistrationStreet labelClassName="label--strong" />

					<RegistrationHouseNumber labelClassName="label--strong" />

					<div className="form__field u-mar--bottom--reset">
						<div className="row form--grid__row">
							<div className="col col-sml-4 form--grid__col">
								<RegistrationZIPCode labelClassName="label--strong" />
							</div>
							<div className="col col-sml-8 form--grid__col">
								<RegistrationCity labelClassName="label--strong" />
							</div>
						</div>
					</div>

					<PartnerRegistrationNationality
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationPOB labelClassName="label--strong" />

					<RegistrationMonthlyLimit
						gamingLimitsData={gamingLimitsData}
						labelClassName="label--strong"
					/>

					<PartnerRegistrationLanguage
						languageData={languageData}
						labelClassName="label--strong"
					/>

					<PartnerRegistrationPromotion />

					<PartnerRegistrationConditions />

					{/* <PartnerRegistrationPartnerIdentificator labelClassName="label--strong" /> */}
				</div>

				<div className="row">
					<div className="col col-sml-6">
						<Button
							type="button"
							atClassName="regContactBtnPrev"
							className="btn--wrap btn--wrap--base btn--block btn--primary--inverted card--onboarding__btn"
							iconLeft
							iconClassName="u-icon--tny u-icon--arrow-left"
							btnText={t("COMMON.PREVIOUS_BUTTON")}
							onClick={previousStep}
						/>
					</div>
					<div className="col col-sml-6">
						<Button
							disabled={isSubmitting}
							atClassName="regContactBtnSubmit"
							className="btn--base btn--block btn--accent"
							btnContent={<>{t<string>("OPEN_ACCOUNT")} *</>}
						/>
					</div>
				</div>

				<div className="card--membership__footer">
					{t("EXISTING_ACCOUNT")}
					<Link
						to={`/${getCurrentCulture()}/auth/login`}
						className="u-anchor u-anchor--primary u-anchor--underline"
					>
						&nbsp;
						{t("COMMON.LOGIN_BUTTON")}
					</Link>
				</div>
			</>
		);
	}
);
